import { createAsyncThunk } from '@reduxjs/toolkit';
import { getClockedInPeople } from '../services/getClockedInPeople.service';

const text = (value) =>
  value === null || value === undefined ? '' : String(value).trim();

/**
 * A person of the API's list as the phone list reads them: names, employer
 * and phone as trimmed text ('' when missing), the picture only when it has
 * a key to load.
 */
export const toClockedInPerson = (person) => ({
  userId: person?.userId || null,
  resourceId: person?.resourceId || null,
  firstName: text(person?.firstName),
  lastName: text(person?.lastName),
  employerName: text(person?.employerName),
  phone: text(person?.phone),
  picture: person?.picture?.key ? person.picture : null,
});

/**
 * Loads who is clocked in to the project right now, for the dashboard's
 * phone list ("Puhelin"). The list is asked for again each time it opens:
 * who is on site changes by the minute.
 */
export const loadClockedInPeople = createAsyncThunk(
  'projectOverview/loadClockedInPeople',
  async ({ projectId }) => {
    const data = await getClockedInPeople({ projectId });
    const people = Array.isArray(data?.people) ? data.people : [];
    return {
      people: people.filter(Boolean).map(toClockedInPerson),
      loadedAt: Date.now(),
    };
  },
  {
    // One request per project at a time.
    condition: ({ projectId }, { getState }) =>
      Boolean(projectId) &&
      getState().projectOverview?.clockedInPeople?.[projectId]?.status !==
        'loading',
  }
);
